<article>
  <header>
    <strong>Categorias Mencionadas</strong>
    <section>
      <app-primary-button
        *ngIf="hasSupervisorRole"
        label="Exportar Relatórios"
        icon="assets/icons/export_report.svg"
        [color]="ButtonColorEnum.common"
        [loading]="isExporting"
        [enabled]="!isLoading && totalItems != 0"
        (clickFunc)="export()"
      ></app-primary-button>
    </section>
  </header>
  <main>
    <app-category-analysis-report-list-header></app-category-analysis-report-list-header>
    <ng-container *ngIf="isLoading">
      <div *ngFor="let i of [1, 2, 3, 4, 5]" class="skeleton">
        <div class="skeleton-column">
          <div class="skeleton-item"></div>
        </div>
      </div>
    </ng-container>
    <app-category-analysis-report-list-item
      *ngFor="let item of categoryAnalysisReportList"
      [data]="item"
    ></app-category-analysis-report-list-item>
    <app-paginator
      [page]="page"
      [totalPages]="totalPages"
      [elementsShowing]="categoryAnalysisReportList.length"
      [totalElements]="totalItems"
      (selectPageFunc)="handleSelectPage($event)"
    ></app-paginator>
  </main>
</article>
